<template>
  <div>
    <main style="">
      <!-- SECTION BANNER -->
      <section class="section-banner">
        <div class="content">
          <!-- BANNER -->
          <div class="banner">
            <Swiper
              :modules="[SwiperEffectFade, SwiperAutoplay]"
              :loop="true"
              :speed="800"
              :effect="'fade'"
              :allow-touch-move="false"
              :autoplay="{
                delay: 5000,
              }"
              @init="onInit"
              @slide-change-transition-start="onSlideChangeTransitionStart"
              @slide-change-transition-end="onSlideChangeTransitionEnd"
            >
              <div class="nagase-overlay"></div>
              <SwiperSlide>
                <div class="parallax ev-charging">
                  <span>ENGAGED</span>
                  <span>FUTURE</span>
                  <span>INNOVATION</span>
                </div>
                <img src="/pages/index/slider/banner01.jpg" alt="" />
              </SwiperSlide>

              <SwiperSlide>
                <img src="/pages/index/slider/banner-02.jpg" alt="" />
                <div class="parallax ocean">
                  <span class="playfair">Care For</span>
                  <span>OCEAN</span>
                  <span class="playfair">Help us reduce plastic waste</span>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <img src="/pages/index/slider/banner-03.jpg" alt="" />
                <div class="parallax discovery">
                  <span>DISCOVERY</span>
                  <span>HIGH - PERFORMANCE PLASTICS</span>
                  <span>FOR YOUR BUSSINESS</span>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <!-- BANNER -->
        </div>
      </section>

      <!-- SECTION BANNER -->

      <section class="bg-primary">
        <div class="container">
          <div class="content">
            <div class="row m-0">
              <div class="col-12 col-md-6 p-0">
                <div class="content">
                  <!-- TEXT WITH DIVIDER -->
                  <div class="text-divider">
                    <span
                      >Nagase Group is one stop service in plastic industry. We
                      offer services covering from material selection, sourcing,
                      logistics and after-sales troubleshooting</span
                    >
                  </div>
                  <!-- TEXT WITH DIVIDER -->
                </div>
              </div>
            </div>

            <div class="content">
              <!-- DIVIDER -->
              <span class="divider"></span>
              <!-- DIVIDER -->
            </div>

            <div class="card-icon-wrapper">
              <!-- CARD ICON -->
              <div class="card-icon">
                <div class="card-icon-title">
                  <i class="fas fa-bullseye"></i>
                  <span>Locally Located</span>
                </div>
                <span class="card-icon-content"
                  >Convenient to contact for every problem. We have local staffs
                  to support throughout Asia Pacific</span
                >
              </div>
              <!-- CARD ICON -->

              <!-- CARD ICON -->
              <div class="card-icon">
                <div class="card-icon-title">
                  <i class="fas fa-fingerprint"></i>
                  <span>Globally Connected</span>
                </div>
                <span class="card-icon-content"
                  >With worldwide network we can operate business to every part
                  of the world</span
                >
              </div>
              <!-- CARD ICON -->

              <!-- CARD ICON -->
              <div class="card-icon">
                <div class="card-icon-title">
                  <i class="far fa-thumbs-up"></i>
                  <span>International Reputation</span>
                </div>
                <span class="card-icon-content"
                  >Nagase Group ranks 1st in Asia Pacific in chemical
                  distribution from ICIS (International Commodity Intelligence
                  Service) in 2022</span
                >
              </div>
              <!-- CARD ICON -->
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION OUR NETWORK COUNTING -->
      <section class="section-our-network">
        <div class="container">
          <div class="content">
            <span class="section-title">OUR NETWORK</span>
            <span class="section-description"
              >Over 190 years of Nagase group history, we have accumulated our
              experience and have grown our network all over the worlds</span
            >

            <div class="counter">
              <!-- COUNTER ITEM -->
              <div class="counter-item">
                <span class="number">100</span>
                <span class="suffix">+</span>
                <span class="label">Offices</span>
              </div>
              <!-- COUNTER ITEM -->

              <!-- COUNTER ITEM -->
              <div class="counter-item">
                <span class="number">18</span>
                <span class="suffix">k</span>
                <span class="label">Business Partners</span>
              </div>
              <!-- COUNTER ITEM -->

              <!-- COUNTER ITEM -->
              <div class="counter-item">
                <span class="number">7</span>
                <span class="suffix">k</span>
                <span class="label">Employees</span>
              </div>
              <!-- COUNTER ITEM -->
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION OUR NETWORK COUNTING -->

      <section class="section-our-expertise bg-primary">
        <div class="container">
          <div class="content">
            <div class="content">
              <!-- SECTION TITLE -->
              <h2 class="section-title h2 text-white text-center h2-caslon">
                Our Expertise
              </h2>
              <!-- SECTION TITLE -->
            </div>

            <div class="row m-0">
              <div class="col-12 col-md-4 p-0 d-none d-md-block">
                <div class="content h-100">
                  <div class="main-card">
                    <img
                      src="/pages/index/our_expertise/nagase-logo-p.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-4 p-0">
                <!-- CARD IMAGE -->
                <div class="card-image">
                  <div class="image-wrapper">
                    <a href="/th/plastics/products">
                      <img
                        src="/pages/index/our_expertise/products.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div class="card-content">
                    <a href="/th/plastics/products" class="card-title"
                      >Product</a
                    >
                    <span class="card-description"
                      >See our plastic resins from various brands</span
                    >
                  </div>
                </div>
                <!-- CARD IMAGE -->
              </div>

              <div class="col-12 col-md-4 p-0">
                <!-- CARD IMAGE -->
                <div class="card-image">
                  <div class="image-wrapper">
                    <a href="/th/plastics/services">
                      <img
                        src="/pages/index/our_expertise/services.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div class="card-content">
                    <a href="/th/plastics/services" class="card-title"
                      >Services</a
                    >
                    <span class="card-description"
                      >One-stop service from consulting to delivery</span
                    >
                  </div>
                </div>
                <!-- CARD IMAGE -->
              </div>

              <div class="col-12 col-md-4 p-0">
                <!-- CARD IMAGE -->
                <div class="card-image">
                  <div class="image-wrapper">
                    <a href="/th/plastics/industries">
                      <img
                        src="/pages/index/our_expertise/industry.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                  <div class="card-content">
                    <a href="/th/plastics/industries" class="card-title"
                      >Industries</a
                    >
                    <span class="card-description"
                      >Main industry sectors that we support</span
                    >
                  </div>
                </div>
                <!-- CARD IMAGE -->
              </div>

              <div class="col-12 col-md-4 p-0">
                <!-- CARD IMAGE -->
                <div class="card-image">
                  <div class="image-wrapper">
                    <a href="/th/plastics/use-cases">
                      <img src="/pages/index/our_expertise/case.jpg" alt="" />
                    </a>
                  </div>
                  <div class="card-content">
                    <a href="/th/plastics/use-cases" class="card-title"
                      >Use Cases</a
                    >
                    <span class="card-description"
                      >See how our products are used in your applications</span
                    >
                  </div>
                </div>
                <!-- CARD IMAGE -->
              </div>

              <div class="col-12 col-md-4 p-0">
                <!-- CARD IMAGE -->
                <div class="card-image">
                  <div class="image-wrapper">
                    <a href="/th/plastics/sustainability">
                      <img src="/pages/index/our_expertise/sus.jpg" alt="" />
                    </a>
                  </div>
                  <div class="card-content">
                    <a href="/th/plastics/sustainability" class="card-title"
                      >Sustainability</a
                    >
                    <span class="card-description"
                      >Our business embraces sustainability</span
                    >
                  </div>
                </div>
                <!-- CARD IMAGE -->
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-our-history">
        <div class="container">
          <div class="content">
            <!-- SECTION TITLE -->
            <h2 class="section-title h2 text-black h2-caslon">Our History</h2>
            <!-- SECTION TITLE -->
          </div>

          <!-- CONTENT IMAGE LEFT TEXT RIGHT -->
          <div class="content-image-text">
            <div class="image">
              <img src="/pages/index/our_history/pic2.png" alt="" />
            </div>
            <div class="content">
              <span class="title">Who we are ?</span>
              <div class="divider"></div>

              <!-- Paragraph tags -->
              <p>
                Founded in 1832, the Nagase group has grown to include over 100
                companies in 20 countries and 6,000 employees worldwide. We
                believe in the power of bringing together good science with
                great people to create customized solutions for the world’s
                changing economic, environmental, and social needs. The Nagase
                group begans as a specialized sales agent securing exclusive
                contracts to sell industry-leading products from around the
                world
              </p>
              <p>
                Over the years, we have leveraged our technology and information
                gathering expertise – as well as our global network- to
                transform our business into a hybrid model offering superior
                manufacturing, processing, and R&D functions as well as trading
                company services. Look forward to our 200th anniversary in the
                year 2032, we are creating a platform for sustainable growth.
              </p>
              <!-- Paragraph tags -->
            </div>
          </div>
          <!-- CONTENT IMAGE LEFT TEXT RIGHT -->
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
useHead({
  title: "Home - NAGASE THAILAND Engineering Plastics",
  meta: [
    {
      rel: "alternate",
      hreflang: "en",
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}`,
    },
  ],
});

const onInit = (swiper) => {
  const textElements =
    swiper.slides[swiper.activeIndex].querySelectorAll(".parallax span");

  setTimeout(() => {
    for (const textElement of textElements) {
      textElement.classList.add("loaded");
    }
  }, 0);
};

const onSlideChangeTransitionStart = (swiper) => {
  const textElements = swiper.slidesEl.querySelectorAll(".parallax span");

  setTimeout(() => {
    for (const textElement of textElements) {
      textElement.classList.remove("loaded");
    }
  }, 0);
};

const onSlideChangeTransitionEnd = (swiper) => {
  const textElements =
    swiper.slides[swiper.activeIndex].querySelectorAll(".parallax span");

  setTimeout(() => {
    for (const textElement of textElements) {
      textElement.classList.add("loaded");
    }
  }, 0);
};
</script>
